import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useStore } from "../../../hook-store/store";
import { getAuthInfo, logoutHandler } from "../../../utils/user";


const GetAuth = (props) => {
  const { } = props;

  const  navigate = useNavigate();

  // const [authCheckStart, setAuthCheckStart] = useState(false);

  const [hStore, hDispatch] = useStore();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const expiryDate = localStorage.getItem("expiryDate");
  
    const tokenRemainNum = new Date(expiryDate).getTime() - new Date().getTime();
    console.log('tokenRemainNum', tokenRemainNum);

    if (!token || tokenRemainNum < 0) {
      getAuthInfo()
      .then((result) => {
        console.log('get authinfo result', result);
    
        const token = localStorage.getItem("token");
        const expiryDate = localStorage.getItem("expiryDate");
        const userId = localStorage.getItem('userId');
        const email = localStorage.getItem('email');
        if (!token || !expiryDate || !userId || !email) {
          hDispatch('SET_ISAUTH', false);
          hDispatch('SET_USERDATA', null);
          logoutHandler();
          return;
        }
    
        // console.log('date', new Date().getTime() - new Date(expiryDate).getTime())
        const tokenRemainNum = new Date(expiryDate).getTime() - new Date().getTime();
        console.log('tokenRemainNum', tokenRemainNum);
        
        if (tokenRemainNum <= 0) {
          // dispatch("SET_AUTHSTATE", false);
          hDispatch('SET_ISAUTH', false);
          hDispatch('SET_USERDATA', null);
          logoutHandler();
          return;
        }
        
        // dispatch("SET_AUTHSTATE", true);
        // window.location.replace('/');
    
        // const userPath = `/?customer-email=${userLoginEmail}`
        // history.replace(userPath);
        setIsLoading(false);
        // window.location.href = window.location.origin;
        navigate("/");
        hDispatch('SET_ISAUTH', true);
        // window.location.replace('/');
        // history.replace('/');
        // window.location.reload();
    
      })
      .catch((err) => {
        console.log('get authinfo error', err);
    
        err.message = "Login failed ...";
        
        setIsLoading(false);
        // dispatch("SET_AUTHSTATE", false);
        hDispatch('SET_ISAUTH', false);
        hDispatch('SET_USERDATA', null);
        logoutHandler();
      });
    }
    else {
      hDispatch('SET_ISAUTH', true);
    }
  },[]);


  return <Fragment></Fragment>;
};

export default GetAuth;
